// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"675ce225","129":"d818d21e"}[chunkId] + ".chunk.css";
};